import { FormControl } from "@angular/forms";

export class Control {

    type?: 'generic' | 'arrayGroup' | 'formGroup';
    name?: string;
    field?: FormControl;
    
    controls?: Array<Control>;

    constructor(init?: Partial<Control>) {
        this.type = "generic";
        Object.assign(this, init);
    }
}